import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { Box, Button, Chip, Skeleton, Typography, } from '@mui/material';
import { MapsHomeWorkRounded, HomeRounded, Language } from '@mui/icons-material';
import { BilledSimTariff } from 'console/sim/types';
const tariffs = {
    [BilledSimTariff.BASE]: {
        Icon: HomeRounded,
        color: 'primary.main',
        button_color: 'primary',
    },
    [BilledSimTariff.BIG]: {
        Icon: MapsHomeWorkRounded,
        color: 'primary.dark',
        button_color: 'secondary',
    },
    [BilledSimTariff.UNLIMITED]: {
        Icon: Language,
        color: 'warning.main',
        button_color: 'warning',
    },
};
export const TariffIcon = forwardRef((props, ref) => {
    const { id, need_color, ...rest } = props;
    const { Icon, color: color_tariff } = useMemo(() => tariffs[id], [id]);
    const color = useMemo(() => (need_color ? color_tariff : undefined), [need_color, color_tariff]);
    return (_jsx(Icon, { sx: {
            color,
        }, ...rest, ref: ref }));
});
TariffIcon.displayName = 'TariffIcon';
export function TariffHeader(props) {
    const { id, title, boxProps, typographyProps, children, variant } = props;
    const { color } = useMemo(() => tariffs[id], [id]);
    const style_variant = useMemo(() => variant == 'filled'
        ? {
            color: 'common.white',
            bgcolor: color,
        }
        : {
            color,
            bgcolor: 'common.white',
        }, [variant, color]);
    return (_jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", boxSizing: "border-box", width: "100%", gap: 2, p: 1, sx: style_variant, children: [_jsxs(Box, { display: "flex", alignItems: "center", gap: 2, ml: 1, ...boxProps, children: [_jsx(TariffIcon, { id: id, fontSize: "large" }), _jsx(Typography, { variant: "h6", ...typographyProps, children: title })] }), children] }));
}
export function SimTariffChip(props) {
    const { id, title, sx, ...rest } = props;
    const { color } = useMemo(() => tariffs[id], [id]);
    const style_variant = useMemo(() => ({
        color: 'common.white',
        bgcolor: color,
        '& .MuiSvgIcon-root': {
            color: 'common.white',
        },
        ...sx,
    }), [color, sx]);
    return (_jsx(Chip, { avatar: _jsx(TariffIcon, { id: id }), label: title, sx: style_variant, ...rest }));
}
export function SimChooseButton(props) {
    const { id, isUpgrade, isCurrent, loading, title, onChoose } = props;
    const { button_color } = useMemo(() => tariffs[id], [id]);
    if (isCurrent) {
        return (_jsx(Typography, { variant: "button", color: "textSecondary", children: "\u0412\u0430\u0448 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0442\u0430\u0440\u0438\u0444" }));
    }
    if (loading) {
        return _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 40 });
    }
    return (_jsx(Button
    //@ts-ignore
    , { 
        //@ts-ignore
        color: button_color, variant: isUpgrade ? 'contained' : 'text', onClick: onChoose, startIcon: _jsx(TariffIcon, { id: id }), children: (isUpgrade ? 'Перейти на ' : 'Выбрать ') + title }));
}
